import { EventEmitter, Input } from "@angular/core";
import { AlertService } from "app/services";
import { SalesService, UserForSalesManagement, UserSalesMessage } from "app/services/sales.service";

export class SalesMessageModalComponentViewModel {

	public isOpen: boolean = false;
	public scrollTop: number = 0;
	public userId: number;
	public userFullName: string;
	public userJobTpText: string;
	public userCmpnyNm: string;
	public messages: UserSalesMessage[] = [];
	public newMessage: string;

	public onMessageModifiedCallback: () => void;

	private init() {
		this.scrollTop = 0;
		this.userId = null;
		this.userFullName = null;
		this.userJobTpText = null;
		this.userCmpnyNm = null;
		this.messages = [];
		this.newMessage = null;
	}
	
	constructor(private salesService: SalesService, private alertService: AlertService) {		
	}


	
	open(userId: number, userFullName: string,	userJobTpText: string,	userCmpnyNm: string) {
		this.init();

		this.userId = userId;
		this.userFullName = userFullName;
		this.userJobTpText = userJobTpText;
		this.userCmpnyNm = userCmpnyNm;
		
		this.salesService.getUserSalesMessages(this.userId, (messages) => this.messages = messages);
		this.isOpen = true;
	}

	close() {
		this.isOpen = false;
		this.init();
	}


	postMessage() {
		this.salesService.postMessage(
			this.userId,
			String(this.newMessage),
			() => {
				this.newMessage = null;

				this.salesService.getUserSalesMessages(this.userId, (messages) =>  {
					this.messages = messages
					
					if (this.onMessageModifiedCallback) {
						this.onMessageModifiedCallback();
					}

				});
			},
			(error: any) => {
				this.alertService.error(error);
			}
		);
	}

	deleteMessage(messageId: number) {
		this.salesService.deleteMessage(
			messageId,
			() => {
				this.newMessage = null;

				this.salesService.getUserSalesMessages(this.userId, (messages) =>  {
					this.messages = messages
					
					if (this.onMessageModifiedCallback) {
						this.onMessageModifiedCallback();
					}

				});
			},
			(error: any) => {
				this.alertService.error(error);
			}
		);
	}

	putMessage(message: UserSalesMessage) {
		message.message = message.tempMessage;

		this.salesService.putMessage(
			message.messageId,
			message.message,
			() => {
				this.newMessage = null;

				this.salesService.getUserSalesMessages(this.userId, (messages) =>  {
					this.messages = messages
					
					if (this.onMessageModifiedCallback) {
						this.onMessageModifiedCallback();
					}

				});
			},
			(error: any) => {
				this.alertService.error(error);
			}
		);
	}

	
}


// WEBPACK FOOTER //
// ./src/app/components/sales/sales-message-modal.viewmodel.ts